module.exports = __webpack_public_path__ + "static/img/icon_cloud4.3ac0508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud4.jpg
// module id = L6gR
// module chunks = 21